export default __webpack_public_path__ + "static/media/student_ms_vanillaJS.dcdb4d2d.PNG";